import { type FC } from 'react';
import { Flex, Text, InlineUnsafe, Separator } from '@/_components';
import type { CustomSectionProps } from './CustomSection.types';

export const CustomSection: FC<CustomSectionProps> = ({
  section,
  showInstruction,
}) => {
  const shouldRender: boolean =
    !!section?.custom_element || !!section?.customElement;

  if (!shouldRender) return null;

  const customElement: string | undefined =
    section?.custom_element || section?.customElement;

  return (
    <Flex isColumn={true} padding={12} gap={12}>
      {section?.instruction && showInstruction && (
        <>
          <Text type="div">
            <InlineUnsafe
              text={section?.instruction}
              isExtremelyUnsafe={true}
            />
          </Text>
          <Separator isLight={true} />
        </>
      )}

      {customElement && (
        <Text type="div">
          <InlineUnsafe text={customElement} isExtremelyUnsafe={true} />
        </Text>
      )}
    </Flex>
  );
};
